import React from 'react';

import { isFalsy } from 'shared/utils/common';
import { useMarketTypeGroupsQuery } from 'features/markets/queries';

import BaseballResultItems from './event-results/BaseballResultItems';
import RacingResultItems from './event-results/RacingResultItems';
import FootballResultItems from './event-results/FootballResultItems';

export default function EventResultWrapper(props: any) {
  const { current_result = {}, eventId, eventTimestamp, weekNumber, weekStartTime, ...rest } = props;
  const { sport_id = 10 } = current_result as any;
  const { data: market_type_groups = [] } = useMarketTypeGroupsQuery();
  const sportIdNum = Number.parseInt(String(sport_id), 10);

  const resultProps = {
    ...rest,
    current_result,
    eventId,
    eventTimestamp,
    weekNumber,
    weekStartTime,
    market_type_groups,
  };

  return (
    <>
      {!isFalsy(current_result) && [10, 11, 20, 21, 30].includes(sportIdNum) && (
        <RacingResultItems {...resultProps} key="racing-result-items" />
      )}

      {!isFalsy(current_result) && sportIdNum === 40 && (
        <BaseballResultItems {...resultProps} key="baseball-result-items" />
      )}

      {!isFalsy(current_result) && sportIdNum === 50 && (
        <FootballResultItems {...resultProps} key="football-result-items" />
      )}
    </>
  );
}

